import React, { useState, useContext, useEffect } from "react";
import { IntlProvider } from "react-intl";
import styled, { css } from "styled-components";

import { createBrowserHistory } from "history";
import PAtabs from "../PAtabs";



import {
  CssTableLine,
  CssSwitchSub,
  CssTableCountry,
  CssTableFlag,
  CssTableDays,
  CssInputDay,
  SelectSquare,
  PAinfoCollapsible,
} from '../uikit2';

import {
  InputCopy,
  FormGroup,
  Select,
  Tooltip,
  StatusDot,
  Checkbox,
  Subheader,
  Pill,
  Button,
  Slider,
  Radio,
  Breadcrumbs,
  Head,
  Card,
  Input,
  RadioGroup,
  Switch,
  Icon,
  ButtonAction,
  Tag,
  Notification,
  ContentBlock
} from "xsolla-uikit";
import PAh2 from "../PAh2";

import { gcCountries } from "../../data/countries";

import PAContentBlock from "../PAContentBlock";

export default function PAgkRefund_old({
  hist,
  name = "Login for My Game: Ultimate Edition",
  status = "draft",
  showAsPage = false,
}) {
  const [page, setPage] = useState("configure");

  const getCountries = () => {
    return gcCountries.map((oneCountry, ind) => ({
      label: (
        <CssTableCountry>
          <CssTableFlag>{oneCountry["icon"]}</CssTableFlag>
          {oneCountry["name"]}
        </CssTableCountry>
      ),
      value: ind
    }));
  };

  return (

      <div
      // className="xsui-width"
      >
        {showAsPage && <FormGroup indentation="md">
          <Breadcrumbs
            extra={
              <div style={{display: 'flex', flexGrow:1, justifyContent:'flex-end'}}>
                <Select
                  name={`vers`}
                  align="right"
                  icon="redo"
                  // placeholder={}
                  input={{
                    value: 1,
                    name: "test",
                    icon: "redo",
                    // value: 'all',
                    placeholder: "df"
                    // onChange: this.setValue
                  }}
                  options={[
                    {
                      value: 1,
                      label: <span>May 2, 2019 → Now</span>,
                      extraLabel: "CURRENT VERSION"
                    },
                    {
                      value: 2,
                      label: <span>Jan 1, 2019 → May 2, 2019</span>
                    }
                  ]}
                  // autosize={true}
                  // size="xs"
                />
              </div>
            }
            //.xsui-breadcrumbs_label {max-width: 100% !important;} //TODO: fix
            items={[
              {
                label: "Game store",
                to: "/game_keys"
              },
              {
                label: (
                  <React.Fragment>
                    <div className="l_flex">
                      Refund policy
                      {/* <div
                      style={{
                        display: "flex",
                        alignItems: "center"
                      }}
                    >
                      <span style={{ margin: "0px 0 0 16px" }}>
                        <Pill
                          appearance={`${
                            status !== "draft" ? `active` : `warning`
                          } `}
                        >
                          <StatusDot
                            status={`${
                              status !== "draft" ? `enabled` : `testing`
                            } `}
                          >
                            {" "}
                            {status}
                          </StatusDot>
                        </Pill>
                      </span>
                    </div> */}
                    </div>
                  </React.Fragment>
                ),
                to: "/login"
              }
            ]}
          />
        </FormGroup>
        }



        <FormGroup indentation="lg">
          <ContentBlock appearance="flatten">
            <FormGroup indentation="lg">
              <FormGroup
                indentation="lg"
                style={{
                  position: "sticky",
                  top: 0
                }}
              >
                <div style={{ marginTop: "-20px" }}>
                  <PAtabs
                    active="configure"
                    handleTab={nw => {
                      setPage(nw);
                      // let url = hist.match.location
                      // setState({
                      //   ...state,
                      //   action: nw
                      // });
                    }}
                    items={[
                      {
                        name: "Configure",
                        stateName: "configure",
                        icon: "settings"
                      },
                      {
                        name: "Preview",
                        stateName: "preview",
                        icon: "show"
                      }
                    ]}
                    extra={<div>
                      <Select
                        name={`vers`}
                        align="right"
                        icon="redo"
                        // placeholder={}
                        input={{
                          value: 1,
                          name: "test",
                          icon: "redo",
                          // value: 'all',
                          placeholder: "df"
                          // onChange: this.setValue
                        }}
                        options={[
                          {
                            value: 1,
                            label: <span>Current version: May 2, 2019 → Now</span>,
                            extraLabel: "CURRENT VERSION"
                          },
                          {
                            value: 2,
                            label: <span>Jan 1, 2019 → May 2, 2019</span>
                          }
                        ]}
                        // autosize={true}
                        // size="xs"
                      />
                    </div>}
                  />
                </div>
              </FormGroup>

              {/* <FormGroup indentation="xs">
                <Head appearance="separated" indentation="md">
                  Set up refund policy
                </Head>
              </FormGroup>

              <PAContentBlock title="General Statements" border={true}>

                <FormGroup indentation="md" label="Cool off period">
                  <p>
                    an interval during which two sides in a disagreement can try to settle their differences before taking further action.
                  </p>
                </FormGroup>

                <FormGroup indentation="md" label="Preview (USA)">
                  <CssRefundQuote>
                    Refund is allowed for this reason. You may get a refund in
                    case the product is not what you thought or you can’t use
                    this. Contact our Customer Support at https://help.xsolla.com/
                    within{" "}
                    <input
                      type="text"
                      value="12"
                      length="3"
                      style={{
                        display: "inline",
                        width: "36px",
                        background: "#f5f9ff",
                        border: "1px solid #c5d0db",
                        padding: "2px 4px",
                        // fontSize: 12,
                        display: "inline-block",
                        borderRadius: 4
                      }}
                    />{" "}
                    days to request a refund.
                  </CssRefundQuote>
                </FormGroup>

                <FormGroup indentation="lg">
                  <Slider
                    input={{
                      name: "rangedSlider",
                      value: [12]
                      // onChange: this.setValue
                    }}
                    range={true}
                    count={3}
                  />
                </FormGroup>

              </PAContentBlock> */}

              {page === "preview" && (
                <FormGroup indentation="lg">
                  <FormGroup label="Preview refund policy">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between"
                      }}
                    >
                      <Select
                        name={`prevew`}
                        icon="redo"
                        autosize={true}
                        // placeholder={<Icon name="redo" size={22} />}
                        input={{
                          name: "test",
                          icon: "redo",
                          value: 1,
                          placeholder: "df"
                          // onChange: this.setValue
                        }}
                        options={getCountries()}

                        // options={[
                        //   {
                        //     value: 1,
                        //     label: <span>USA</span>,
                        //     extraLabel: "default"
                        //   },
                        //   {
                        //     value: 2,
                        //     label: <span>Russia</span>,
                        //   }
                        // ]}
                      />

                      <Button appearance="outline">
                        <Icon name="download" />
                        Download PDF
                      </Button>
                    </div>
                  </FormGroup>

                  <FormGroup>
                    <div
                      style={{
                        height: "800px",
                        backgroundColor: "#F6F9FE",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "contain",
                        backgroundPosition: "50% 0",
                        backgroundImage:
                          'url("https://res.cloudinary.com/maiik/image/upload/v1568879969/Xsolla_PA/ref_preview.jpg")'
                      }}
                    ></div>
                  </FormGroup>
                </FormGroup>
              )}

              {page === "configure" && (
                <div className="">
                {/* <PAContentBlock title="Info" border={true}> */}

                  {/* <FormGroup
                    indentation="lg"
                  >
                    <PAinfoCollapsible
                      isOpen={true}
                      title="Refund policy configuration tips"
                    >
                    123
                    </PAinfoCollapsible>
                  </FormGroup> */}

                {/* </PAContentBlock> */}



                <PAgkRefundBb/>



                </div>
              )}
            </FormGroup>
          </ContentBlock>
        </FormGroup>
      </div>

  );
}



export const PAgkRefundBb = ({}) => {
  return(
      <PAContentBlock
      title="Game store" border={true}
        // sticky="Strict policy"
      >
        <FormGroup
          indentation="md"
          label="Allow refund in the following cases"
        ></FormGroup>

        {gcRefunds.map((oneRef, ind) => {
          return <PAgkRefundOption oneRef={oneRef} index={ind} />;
        })}
      </PAContentBlock>
  )
}






export const PAgkRefundPeriods = ({
  val = "max",
  index = 0,
  handlePeriod = () => {
    void 0;
  }
}) => {
  const changeVal = ({ ind, cur, newVal }) => {};

  const [cur, setCur] = useState(val);

  return (
    <FormGroup label="Select preset" indentation="md">


      <FormGroup indentation="xs">
        <Radio
          name={`rad_${index}_1`}
          input={{
            value: cur,
            onChange: e => {
              setCur(e.target.value);
              handlePeriod(e.target.value);
            }
          }}
          label={<CssPreset><CssEmoji>👌</CssEmoji>Loyal</CssPreset>}
          tooltip="180 days for most countries.
          Australia — unlimited. Saudi Arabia: 365"
          radioValue="max"
        />
      </FormGroup>

      <FormGroup indentation="xs">
        <Radio
          name={`rad_${index}_1`}
          input={{
            value: cur,
            onChange: e => {
              setCur(e.target.value);
              handlePeriod(e.target.value);
            }
          }}
          label={<CssPreset><CssEmoji>👋</CssEmoji>Moderate (recommended)</CssPreset>}
          tooltip="180 days for most countries.
          Australia — unlimited. Saudi Arabia: 365"
          radioValue="max"
        />
      </FormGroup>


      <FormGroup indentation="xs">
        <Radio
          name={`rad_${index}_0`}
          input={{
            value: cur,
            onChange: e => {
              setCur(e.target.value);
              handlePeriod(e.target.value);
            }
          }}
          label={<CssPreset><CssEmoji>⚠️</CssEmoji>Strict</CssPreset>}
          tooltip={
            <div style={{ textAlign: "left" }}>
              <p>
                <b>Typically from 0 to 36 days.</b>
              </p>
              <p>Minimum period under the legislation of the counry.</p>
              <div>
                🇦🇺 Australia:{" "}
                <strong style={{ color: "hotpink" }}>unlimited</strong>.
              </div>
              <div>
                🇸🇦 Saudi Arabia: <strong>365 days</strong>
              </div>
              <div>
                🇷🇺 Russia: <strong>2 years</strong>
              </div>
            </div>
          }
          radioValue="min"
        />
      </FormGroup>



      <FormGroup indentation="xs">
        <Radio
          name={`rad_${index}_2`}
          input={{
            value: cur,
            onChange: e => {
              setCur(e.target.value);
              handlePeriod(e.target.value);
            }
          }}
          label="Custom"
          radioValue="defaultPeriod"
        />
      </FormGroup>

      <FormGroup label="Settings by country">
        <PAinfoCollapsible
          title={() => {
            return (
              <div
                style={{
                  display: "flex",
                  justifyContent: "stretch",
                  alignItems: "center",
                  position: "relative",
                  // marginTop: '-8px',
                  height: "24px",
                  width: "100%"
                }}
              >
                <div style={{ flexGrow: 1 }}>
                  {formatDescr(
                    "{{cooling}} days for most countries",
                    gcCountries[16][cur],
                    false
                  )}
                </div>
                {cur === "defaultPeriod" && (
                  <SelectSquare
                    onClick={e => {
                      e.preventDefault();
                    }}
                  >
                    <Select
                      name={`reset_all_${index}`}
                      icon="redo"
                      placeholder={<Icon name="redo" size={22} />}
                      input={{
                        name: "test",
                        icon: "redo",
                        // value: 'all',
                        placeholder: "df"
                        // onChange: this.setValue
                      }}
                      options={[
                        {
                          value: 1,
                          label: <span>Reset all to minimum </span>,
                          extraLabel: "6-8 days"
                        },
                        {
                          value: 2,
                          label: <span>Reset all to maximum </span>,
                          extraLabel: "Up to 365 days"
                        }
                      ]}
                      autosize={true}
                      size="xs"
                    />
                  </SelectSquare>
                )}
              </div>
            );
          }}
          indentation="xs"
        >
          {gcCountries.map((oneCountry, ind) => {
            return (
              <PAgkRefundLine
                key={ind}
                ind={ind}
                cur={cur}
                oneCountry={oneCountry}
                handleChange={newCur => {
                  setCur(newCur);
                }}
              />
            );
          })}
        </PAinfoCollapsible>
      </FormGroup>

    </FormGroup>
  );
};

const formatDescr = (line, cooling = 12, inInput = true) => {
  line = line.split("{{cooling}}");
  if (line.length > 1) {
    return (
      <p>
        {line[0]}{" "}
        <Tooltip
          label={
            <div style={{ fontSize: "11px" }}>
              <p>
                <b>Cooling off period</b> is an interval during which two sides
                in a disagreement can try to settle their differences before
                taking further action.
              </p>
              <p>
                The minimum varies from counry to counrty. Recommended setting
                is 14 business days.
              </p>
            </div>
          }
        >
          {!inInput && <b>{cooling}</b>}
          {inInput && (
            <input
              type="text"
              value={cooling}
              length="3"
              style={{
                display: "inline",
                width: "36px",
                background: "#f5f9ff",
                border: "1px solid #c5d0db",
                textAlign: "center",
                padding: "2px 4px",
                // fontSize: 12,
                display: "inline-block",
                borderRadius: 4
              }}
            />
          )}
        </Tooltip>{" "}
        {line[1]}
      </p>
    );
  } else {
    return line[0];
  }
};

export function PAgkRefundOption({ oneRef, index = 0 }) {
  const [onoff, setOnoff] = useState(true);

  const [cur, setCur] = useState("max");

  return (
    <FormGroup border="lg" key={`ref_${index}`}>
      <FormGroup indentation="xs">
        <Switch
          name={`ref_${index}`}
          size="sm"
          // label='Allow refund with this reason'
          label={oneRef["title"]}
          tooltip=""
          input={{
            value: onoff,
            onChange: e => {
              setOnoff(!onoff);
            }
          }}
        />
      </FormGroup>

      <CssSwitchSub>
        {!!oneRef["description"] && (
          <FormGroup label="Preview (USA / default)" indentation="md">
            <CssRefundQuote>
              {onoff &&
                formatDescr(oneRef["description"], gcCountries[16][cur])}
              {!onoff && oneRef["descriptionNeg"]}
            </CssRefundQuote>
          </FormGroup>
        )}

        {!onoff && oneRef["warning"] && (
          <Notification
            // title={oneRef['warning']}
            title="These countries have legislatively defined minimums for this type of request:"
            status="warning"
            icon={true}
          >
            {gcCountries.map((oneCountry, ind) => {
              if (
                oneCountry["blocked"] &&
                oneCountry["blocked"].indexOf(index) >= 0
              ) {
                return (
                  <div className="" key={ind}>
                    {oneCountry["name"]}: {oneCountry["min"]} days
                  </div>
                );
              } else {
                return null;
              }
            })}
          </Notification>
        )}

        {onoff && (
          <PAgkRefundPeriods
            index={index}
            val={oneRef["defaultPeriod"]}
            handlePeriod={setCur}
          />
        )}
      </CssSwitchSub>
    </FormGroup>
  );
}

const CssRefundQuote = styled.div`
  font-size: 14px;
  color: #00244d;
  line-height: 1.4em;
  padding-left: 16px;
  border-left: 2px solid #00244d;
`;

export const PAgkRefundLine = ({
  key = 0,
  ind = 0,
  cur = "max",
  oneCountry,
  handleChange = () => {
    void 0;
  }
}) => {
  const [current, setCurrent] = useState(cur || "defaultPeriod");

  const [inp, setInp] = useState(oneCountry[cur]);
  const handleFocus = event => event.target.select();
  let timeOut;

  useEffect(() => {
    // debugger
    if (cur === current) {
      if (inp > oneCountry["max"]) {
        timeOut = setTimeout(() => {
          setCustom(oneCountry["max"]);
        }, 500);
      }

      if (inp < oneCountry["min"]) {
        timeOut = setTimeout(() => {
          setCustom(oneCountry["min"]);
        }, 500);
      }
    }

    return () => {
      timeOut && clearTimeout(timeOut);
    };
  });

  useEffect(() => {
    if (inp !== oneCountry[current]) {
      handleChange("defaultPeriod");
    }
  }, [inp]);

  useEffect(() => {
    setCustom(oneCountry[current]);
  }, [current]);

  useEffect(() => {
    if (cur !== current) {
      console.log("cur = ", cur);
      console.log("current = ", current);
      setCurrent(cur);
    }
  }, [cur, current]);

  const setCustom = val => {
    setInp(val);
    gcCountries[ind]["defaultPeriod"] = val;
  };

  return (
    <CssTableLine key={ind}>
      <CssTableCountry>
        <CssTableFlag>{oneCountry["icon"]}</CssTableFlag>
        {oneCountry["name"]}
      </CssTableCountry>

      {oneCountry["defaultPeriod"] !== false && (
        <CssTableDays>
          <CssInputDay>
            <Input
              style={{ width: 64 }}
              key={ind}
              size="sm"
              input={{
                name: `name.${ind}`,
                value: inp,
                onFocus: handleFocus,
                onChange: e => {
                  let val = e.target.value;
                  setInp(val);
                }
              }}
            />
          </CssInputDay>
          days
          <SelectSquare>
            <Select
              name={`reset_${ind}`}
              icon="redo"
              placeholder={<Icon name="redo" size={22} />}
              input={{
                name: "test",
                icon: "redo",
                // value: 'all',
                placeholder: "df",
                onChange: e => {
                  setCurrent(e);
                }
              }}
              options={[
                {
                  value: "min",
                  label: <span>Reset to minimum </span>,
                  extraLabel: `${oneCountry["min"]} days`
                  // onChange: e => {
                  //   setCurrent('min');
                  // }
                },
                {
                  value: "max",
                  label: <span>Reset to maximum </span>,
                  extraLabel: `${oneCountry["max"]} days`
                  // onClick: e => {
                  //   setCurrent('max');
                  // }
                }
              ]}
              autosize={true}
              size="xs"
            />
          </SelectSquare>
        </CssTableDays>
      )}

      {oneCountry["defaultPeriod"] === false && (
        <CssTableDays>
          Unlimited&nbsp;
          <Tooltip
            label={
              <div style={{ textAlign: "left" }}>
                <p>
                  In Australia the minimum priod is <b>unlimited</b> days.
                </p>
              </div>
            }
          />
        </CssTableDays>
      )}
    </CssTableLine>
  );
};












const gcRefunds = [
  {
    title: "Duplicate purchase",
    defaultPeriod: "max",
    description:
      "Refund is allowed for this reason. In this case please contact our Customer Support at https://help.xsolla.com/. A refund will be provided for the duplicate purchase provided it has been made within 5 minutes of the last transaction for the same item.",
    descriptionNeg:
      "Refund is not allowed for this reason. Unfortunately, game keys couldn’t be refunded because each key was provided for every transaction.",
    warning: "This is highly NOT recommended"
  },
  {
    title: "Software wasn’t compatible with an existing setup",
    defaultPeriod: "max",
    description:
      "Refund is allowed for this reason. In case there are some problems with running purchased software, you may request a refund at https://help.xsolla.com/ with your payment ID within {{cooling}} business days from the purchase date.",
    descriptionNeg:
      "Refund is not allowed for this reason. Please note that we do not bear any responsibility and therefore we do not satisfy any refund/return/exchange requests based on the incompatibility of our Software with some third-party software (plug-ins, add-ons, modules, search engines, scripts, extensions etc.) other than those which are specified as compatible in a description available on the preview page of each one. We don’t guarantee that the Software are fully compatible with any third-party programs and we do not provide support for third-party applications.",
    warning: "This is highly NOT recommended"
  },
  {
    title: "Software didn’t function as expected",
    defaultPeriod: "max",
    description:
      "Refund is allowed for this reason. In case there you encountered this problem, contact our support team at  https://help.xsolla.com/ with your payment ID within {{cooling}} business days from the purchase date.",
    descriptionNeg:
      "Refund is not allowed for this reason. Although all the Software are thoroughly tested before release, unexpected errors may occur. Such issues must be reported directly to the vendor. Please be advised that the vendor can request temporary access to your server to identify and fix the issue. A failure to provide such access in a timely manner may result in a delayed resolution of the issue.",
    warning: "This is highly NOT recommended"
  }
];

const CssPreset = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

const CssEmoji = styled.div`
  /* background: #efefef; */
  background: #ffffff;
  border-radius: 100px;
  text-align: center;
  /* margin-right: 0.4em; */
  padding: 2px 0 0 4px;
  font-size: 13px;
  min-height: 22px;
  min-width: 22px;
`

const CssInfoGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-column-gap: 24px;

`







const PArefundConfigSimple = () => {
  return(
    <div className="">
      <FormGroup indentation="xs">
                <Head appearance="separated" indentation="md">
                  Set up refund policy
                </Head>
              </FormGroup>

              <PAContentBlock title="General Statements" border={true}>
                <FormGroup indentation="md" label="Cool off period">
                  <p>
                    an interval during which two sides in a disagreement can try to settle their differences before taking further action.
                  </p>
                  </FormGroup>
                <FormGroup indentation="md" label="Preview (USA)">

                <CssRefundQuote>
                  Refund is allowed for this reason. You may get a refund in
                  case the product is not what you thought or you can’t use
                  this. Contact our Customer Support at https://help.xsolla.com/
                  within{" "}
                  <input
                    type="text"
                    value="12"
                    length="3"
                    style={{
                      display: "inline",
                      width: "36px",
                      background: "#f5f9ff",
                      border: "1px solid #c5d0db",
                      padding: "2px 4px",
                      // fontSize: 12,
                      display: "inline-block",
                      borderRadius: 4
                    }}
                  />{" "}
                  days to request a refund.
                </CssRefundQuote>
                </FormGroup>

                <FormGroup indentation="lg">
                  <Slider
                    input={{
                      name: "rangedSlider",
                      value: [12]
                      // onChange: this.setValue
                    }}
                    range={true}
                    count={3}
                  />
                </FormGroup>
              </PAContentBlock>
    </div>
  )
}